import React from 'react'
import DynamicImageSelect from './DynamicImageSelect'
import DynamicSelect from './DynamicSelect'
import PleatToTheStripe from './PleatToTheStripe'
const DynamicFormControls = (props) => {
   const { controls, form, formState, setFormState, step, basketState,
      setBasketState, activeIndex, listData, modelLoaded } = props
   const { materialId } = step


   const renderControls = () => {
      const renderControls = !controls ? null : Object.values(controls).map(control => {
         switch (control.type) {
            case 'SELECT':
               return <DynamicSelect
                  key={control.name}
                  {...control}
                  form={form}
                  formState={formState}
                  setFormState={setFormState}
               />
            case 'ACCORDION_SELECT':
               return <DynamicImageSelect
                  activeIndex={activeIndex}
                  key={control.id}
                  step={step}
                  basketState={basketState}
                  setBasketState={setBasketState}
                  {...control}
                  formState={formState}
                  setFormState={setFormState}
                  materialId={materialId}
                  listData={listData}
                  modelLoaded={modelLoaded}
               />
            case 'PLEAT_TO_STRIPE':
               return <PleatToTheStripe
                  key={control.id}
                  basketState={basketState}
                  setBasketState={setBasketState}
                  options={control}
                  formState={formState}
                  setFormState={setFormState}
               />
            default:
               return null
         }
      })

      return renderControls
   }

   return renderControls()

}
export default DynamicFormControls